// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"d4abae7a","62":"2e07aa60","375":"d4e4bc6b","512":"6d7703c3"}[chunkId] + ".chunk.js";
};